import { useState } from "react";
import { AssetSummary, AssetSummaryFactory } from "../commons/assetSummary";
import { IAssetInfo } from "../models/asset";
import useAuthHttp from "./useAuthHttp";


export const useFindAsset = () => {
    const { doGet } = useAuthHttp();
    const [assetList, setAssetList] = useState<AssetSummary[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    
    const findAsset = async (searchText: string): Promise<void> => {
        try {
            if (!searchText || searchText.length < 3) {
                return;
            }

            setIsLoading(true);
            const result = await doGet<{asset_list: IAssetInfo[]}>(`/asset/find?search=${searchText}`);

            if (!result) {
                return;
            }

            const assetList = result
                .asset_list
                ?.map(asset => {
                    return AssetSummaryFactory.createFromDetailsResponse(asset);
                }) ?? [];

            setAssetList(assetList);
        } catch (err) {
            console.error(err);
            return;
        } finally {
            setIsLoading(false);
        }
    }

    return { findAsset, assetList, setAssetList, isLoading };
}
